import { render, staticRenderFns } from "./pricing-grid.vue?vue&type=template&id=e1625c22&"
import script from "./pricing-grid.vue?vue&type=script&lang=js&"
export * from "./pricing-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports